import { addDays } from 'date-fns';

/** Fim sugerido pelo aviso do pool (T3): data do aviso + número de dias. */
export function noticeEndDate(noticeDate: Date, noticeDays: number): Date {
  return addDays(noticeDate, noticeDays);
}
